import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Horarios from '../../../componentes/horario';
import Formulario from '../../../componentes/herramientas/formulario';
import { genera_formulario, conexiones, Form_todos, Ver_Valores } from '../../../constantes';

import Cargando from '../../../componentes/esperar/cargar';
import Logo from '../../../imagenes/logo.png';


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : 'rgb(5, 30, 52)',
  backgroundImage: "linear-gradient(180deg, #00ffff 0, #00e5ff 12.5%, #10a6f8 25%, #10a6fa 37.5%, #1e6ca3 50%, #1e6ca5 62.5%, #153959 75%, #15395b 87.5%, #000000 100%)",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  
}));

export default function Horarios_uecla(props) {
    const [state, setState] = React.useState({cargando:true});
    const [cargando, setCargando] = React.useState(true);
    const cambio = (valores)=>{
        setState({...state,...valores})
    }
    const {User} = Ver_Valores();
    const permiso = [0,1].indexOf(Number(User.categoria))!==-1 
                        || (User.permisos && User.permisos.indexOf('Horario_modificar')!==-1);
    // const Seleccion_Horario = (formulario)=> async(valores)=>{
    //     const {name, resultados}= valores;
    //     formulario.titulos[0].value.lista.onChange= Seleccion_Horario(formulario);
    //     cambio({datos:{...resultados[name], periodo:resultados.periodo.periodo, tipo: resultados.tipo.value}, formulario})
    // }

    const Seleccion = async(valores)=>{
        const {resultados}= valores;
        
        if(resultados.tipo && resultados.periodo && resultados.lista && resultados.grado){
            setCargando(valores)
        }
        
        return valores
    }
    
    
    React.useEffect(()=>{
        
        let active = true;

        if (!cargando) {
        return undefined;
        }

        if (cargando && state.formulario===undefined){
            //Inicio
            (async () => {
                let formulario = await genera_formulario({ valores:{}, campos: Form_todos('Form_horario') });
                formulario.titulos[0].value.grado.onChange = Seleccion;
                formulario.titulos[0].value.periodo.onChange = Seleccion;
                formulario.titulos[0].value.tipo.onChange = Seleccion;
                formulario.titulos[0].value.lista.onChange = Seleccion;
                formulario.titulos[0].value.periodo.value= formulario.titulos[0].value.periodo.lista.length!==0 ? formulario.titulos[0].value.periodo.lista[0]:null;
                formulario.titulos[0].value.grado.value= formulario.titulos[0].value.grado.lista.length!==0 ? formulario.titulos[0].value.grado.lista[0]:null;
                formulario.titulos[0].value.tipo.value= formulario.titulos[0].value.tipo.lista.length!==0 
                            ? Number(User.categoria)===3 && !permiso
                                ? formulario.titulos[0].value.tipo.lista[1]
                                : formulario.titulos[0].value.tipo.lista[0]
                            : null;
                formulario.titulos[0].value.lista.value= formulario.titulos[0].value.lista.lista.length!==0 ? formulario.titulos[0].value.lista.lista[0]:null;
                // formulario.titulos[0].value.lista.placeholder='Sección';
                
                
                if (active) {
                    cambio({formulario, datos:[]});
                    setCargando(false)
                    setTimeout(() => {
                        Seleccion({resultados:{
                            periodo:formulario.titulos[0].value.periodo.value,
                            grado:formulario.titulos[0].value.grado.value,
                            tipo:formulario.titulos[0].value.tipo.value,
                            lista:formulario.titulos[0].value.lista.value
                        }})
                    }, 500);
                }
            })();
            return
        }
        (async () => {
            //Buscar los datos
            const {resultados}= cargando;
            
            // let datos= await conexiones.Leer_C([`uecla_horario`, ...resultados.tipo.value==='seccion' ? ['uecla_asignatura','uecla_docente'] :[]], 
            //     {
            //         [`uecla_horario`]:{$and:[{'valores.periodo':resultados.periodo.periodo},{'valores.tipo':resultados.tipo.value}]},//{$text: {$search: resultados.carrera.nombres, $caseSensitive: false}},
            //         ...resultados.tipo.value==='seccion' ? {uecla_asignatura:{}, uecla_docente:{}} :{}
            //     }
            // );
            let datos= await conexiones.Leer_C(['uecla_asignatura','uecla_docente','uecla_aula'], 
                {
                    uecla_asignatura:{}, 
                    uecla_docente:{},
                    uecla_aula:{}
                }
            );
            if (datos.Respuesta==='Ok'){
                let asignaturas = datos.datos[`uecla_asignatura`] ? datos.datos[`uecla_asignatura`].map(val=>{return {_id:val._id,...val.valores}}) : [];
                let docentes = datos.datos[`uecla_docente`] ? datos.datos[`uecla_docente`].map(val=>{return {_id:val._id,...val.valores}}) : [];
                let aulas = datos.datos[`uecla_aula`].map(val=>{return {_id:val._id,...val.valores}});
                // datos= datos.datos[`uecla_horario`]
                datos ={
                        periodo:resultados.periodo.periodo, 
                        tipo:resultados.tipo.value,
                        grado:resultados.grado.titulo,
                        // seccion:resultados.lista.titulo,
                        _id: `${resultados.grado.titulo}-${resultados.lista.titulo}`,
                        titulo:`${resultados.grado.titulo} ${resultados.lista.titulo}`,
                };
                
                if (resultados.tipo.value==='seccion'){
                    // datos = datos.filter(f=>{
                    //     return f.valores.titulo===`${resultados.grado.titulo} ${resultados.lista.titulo}`
                    // }).map(val=>{return {...val.valores, titulo:val.valores.titulo, _id:val._id}})
                    // console.log(datos)
                    asignaturas = asignaturas.filter(f=>{
                        return f.grado.value===resultados.grado.value
                    }).map(val=>{return {_id:val._id, ...val, titulo:`${val.asignatura}`}});
                    docentes = docentes.filter(f=>{
                        const o = f.grados ? f.grados.filter(f1=>f1.value===resultados.grado.value):[];
                        return o.length!==0
                    }).map(val=>{return {...val, titulo:`${val.nombres} ${val.apellidos}`}});
                    
                    datos ={
                        ...datos,
                        asignaturas, docentes
                    };
                }else if(resultados.tipo.value==='docente'){
                    docentes = docentes.map(val=>{return {...val, titulo:`${val.nombres} ${val.apellidos}`}});
                    docentes = Number(User.categoria)===3 && !permiso ? docentes.filter(f=>f._id===User._id) : docentes;
                    
                    datos={
                        ...datos,
                        _id: resultados.grado._id,
                        titulo:`${resultados.grado.titulo}`,
                        docente:resultados.grado
                    }
                }else{
                    //aulas
                    aulas = aulas.map(val=>{return {...val, titulo:`${val.nombre}`}});
                    datos={
                        ...datos,
                        _id: resultados.grado._id,
                        titulo:`${resultados.grado.titulo}`,
                    }
                }
                
                const formulario1 = await genera_formulario({ valores:{...resultados}, campos: Form_todos('Form_horario') });
                const formulario ={...formulario1};
                formulario.titulos[0].value.grado.onChange = Seleccion;
                formulario.titulos[0].value.periodo.onChange = Seleccion;
                formulario.titulos[0].value.tipo.onChange = Seleccion;
                formulario.titulos[0].value.tipo.disabled=Number(User.categoria)===3 && !permiso;
                formulario.titulos[0].value.lista.onChange = Seleccion;
                if(resultados.tipo.value==='seccion'){
                    const pos = Ver_Valores().config.Listas.lista_colegio_grado.findIndex(f=> f._id===resultados.grado._id);
                    if (pos===-1){
                        formulario.titulos[0].value.grado.value=Ver_Valores().config.Listas.lista_colegio_grado[0];
                        datos ={
                            ...datos,
                            grado:Ver_Valores().config.Listas.lista_colegio_grado[0].titulo,
                            // seccion:resultados.lista.titulo,
                            _id: `${Ver_Valores().config.Listas.lista_colegio_grado[0].titulo}-${resultados.lista.titulo}`,
                            titulo:`${Ver_Valores().config.Listas.lista_colegio_grado[0].titulo} ${resultados.lista.titulo}`,
                        };
                    }
                } else if(resultados.tipo.value==='docente'){
                    formulario.titulos[0].value.grado.lista=docentes;
                    formulario.titulos[0].value.grado.placeholder='Doncente';
                    formulario.titulos[0].value.grado.title='Doncente';
                    formulario.titulos[0].value.grado.label='Doncente';
                    const pos = docentes.findIndex(f=> f._id===resultados.grado._id)
                    console.log(pos)
                    if (pos===-1){
                        formulario.titulos[0].value.grado.value=docentes[0];
                        datos={
                            ...datos,
                            _id: docentes[0]._id,
                            titulo:`${docentes[0].titulo}`,
                            docente:docentes[0]
                        }
                    }
                    delete formulario.titulos[0].value.lista
                }else{
                    //aulas
                    formulario.titulos[0].value.grado.lista=aulas;
                    formulario.titulos[0].value.grado.placeholder='Aula';
                    formulario.titulos[0].value.grado.title='Aula';
                    formulario.titulos[0].value.grado.label='Aula';
                    const pos = aulas.findIndex(f=> f._id===resultados.grado._id)
                    if (pos===-1){
                        formulario.titulos[0].value.grado.value=aulas[0];
                        datos={
                            ...datos,
                            _id: aulas[0]._id,
                            titulo:`${aulas[0].titulo}`,
                        }
                    }
                    delete formulario.titulos[0].value.lista
                }
                console.log(formulario.titulos[0].value.grado);
                // formulario.titulos[0].value.lista.disabled= false;
                // formulario.titulos[0].value.lista.lista= datos;
                // formulario.titulos[0].value.lista.value= null;
                // formulario.titulos[0].value.lista.onChange= Seleccion_Horario(formulario);
                if (active) {
                    cambio({formulario, datos})   
                }
                
            }

            setCargando(false)
        })();

        return () => {
        active = false;
        };

    },[cargando])




    // if (state.formulario===undefined){
    //     Inicio()
        
    // }
    
    return state.formulario ? (
        <Box sx={{ flexGrow: 1, position: "relative"}}>
            <Grid container spacing={0.5}>
                <Grid item xs={12}>
                    <Item style={{height: 100, color:'#fff'}}>
                        <Formulario {...state.formulario}
                            config={{
                                Estilos:{
                                    Input_label:{color:'#fff'},
                                    Input_fondo:'#fff',
                                    Input_input:{color:'#fff'}
                                }
                            }}
                        />
                    </Item>
                </Grid>
                <Grid item xs={12} >
                    <Item style={{}}>
                        <Horarios {...props} Datos={state.datos} Table={'unefa_horario'} Logo={Logo}/>
                    </Item>
                </Grid>
            </Grid>
            <Cargando open={cargando} Logo={Logo} Fondo={'#ffffff'}/>
        </Box>
    ): null;
}
